import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function BrochureButton() {
  const [visible, setVisible] = useState(false);
  const [hovered, setHovered] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 120);
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Don't show on the brochure page or admin panel
  if (location.pathname === "/brochure" || location.pathname.startsWith("/admin")) return null;

  return (
    <div
      className={`fixed right-0 top-1/2 -translate-y-1/2 z-50 hidden sm:flex items-center transition-all duration-500 ${
        visible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-full"
      }`}
      style={{ pointerEvents: visible ? "auto" : "none" }}
    >
      <button
        onClick={() => navigate("/brochure")}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        className="group flex items-center gap-0 cursor-pointer whitespace-nowrap overflow-hidden rounded-l-xl"
        style={{
          background: "linear-gradient(135deg, #C9A84C 0%, #E2C27A 50%, #C9A84C 100%)",
          boxShadow: "-4px 4px 20px rgba(201,168,76,0.35)",
          transition: "all 0.35s cubic-bezier(0.4,0,0.2,1)",
          maxWidth: hovered ? "200px" : "44px",
          height: "44px",
          paddingLeft: "12px",
          paddingRight: hovered ? "16px" : "12px",
        }}
        aria-label="Download Brochure"
      >
        <div className="w-5 h-5 flex items-center justify-center flex-shrink-0">
          <i className="ri-file-download-line text-[#071A2E] text-base leading-none" />
        </div>
        <span
          className="text-[#071A2E] font-bold text-xs uppercase tracking-wide ml-2 flex-shrink-0"
          style={{
            opacity: hovered ? 1 : 0,
            maxWidth: hovered ? "140px" : "0px",
            overflow: "hidden",
            transition: "opacity 0.25s ease, max-width 0.35s cubic-bezier(0.4,0,0.2,1)",
            whiteSpace: "nowrap",
          }}
        >
          Download Brochure
        </span>
      </button>
    </div>
  );
}
